import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['inputs', 'labels'];

  connect() {
  }

  toggle(event) {
    // Unselect all other radio buttons in the group
    const { name } = event.target;
    document.querySelectorAll(`input[name="${name}"]`).forEach((input) => {
      if (input !== event.target) {
        input.checked = false;
      } else {
        input.checked = true;
      }
    });

    // Select current radio button
    event.target.checked = true;
  }
}
